import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPeopleVoice: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="people-voice, user, person"><path d="M20.75 8V12M17.25 3V17M13.75 6V14M10.25 4V7" stroke="currentColor" strokeWidth="1.5"/><path d="M3.25 20.25V20C3.25 17.6528 5.15279 15.75 7.5 15.75C9.84721 15.75 11.75 17.6528 11.75 20V20.25H3.25Z" stroke="currentColor" strokeWidth="1.5"/><circle cx="7.5" cy="11.5" r="2" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconPeopleVoice;
